import React, { useEffect, useState } from "react";
import { EntityType, Ticker } from "../../../_app/types";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { setBase, setQuote } from "../../../store/slices/botSlice";
import { setStrategyBase, setStrategyQuote } from "../../../store/slices/strategySlice";
import { useTheme } from "@mui/material/styles";
import { useWebApp } from "@vkruglikov/react-telegram-web-app";
import SearchField from "../../../_components/SearchField";
import CurrencyCard from "./CurrencyCard";
import Spacer from "../../../_components/Spacer";

const STRATEGY_TICKERS = [
  "BTC",
  "SOL",
  "BNB",
  "DOGE",
  "XRP",
  "ADA",
  "AVAX",
  "TRX",
  "TON",
  "ETH",
  "HPOS10I",
  "TAO",
];

interface Props {
  tickers: Ticker[];
  entity: EntityType;
}

const TickerChooseList = ({ tickers, entity }: Props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const WebApp = useWebApp();
  const [searchValue, setSearchValue] = useState<string>("");

  // TODO костыль для тикеров стратегий, их пока 10;
  const [strategyTickers, setStrategyTickers] = useState<Ticker[]>([]);

  const filteredTickers = React.useMemo(
    () =>
      tickers.filter(
        (ticker) =>
          ticker.base.toLowerCase().includes(searchValue.toLowerCase()) ||
          ticker.quote.toLowerCase().includes(searchValue.toLowerCase()) ||
          (ticker.base + ticker.quote).toLowerCase().includes(searchValue.toLowerCase())
      ),
    [tickers, searchValue]
  );

  const filteredStrategyTickers = React.useMemo(
    () =>
      strategyTickers.filter((ticker) =>
        ticker.base.toLowerCase().includes(searchValue.toLowerCase())
      ),
    [strategyTickers, searchValue]
  );

  const handleBase = (value: string) => {
    entity === "bot" && dispatch(setBase(value));
    entity === "strategy" && dispatch(setStrategyBase(value));
  };

  const handleQuote = (value: string) => {
    entity === "bot" && dispatch(setQuote(value));
    entity === "strategy" && dispatch(setStrategyQuote(value));
  };

  useEffect(() => {
    if (entity === "strategy") {
      const tickersStrategy = tickers.filter(
        (item) => STRATEGY_TICKERS.includes(item.base) && item.quote !== "USDC"
      );
      setStrategyTickers(tickersStrategy);
    }
  }, []);

  return (
    <Box className="layout">
      <Box
        className="layout-fixed-wrapper"
        sx={{
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          marginBottom: "24px",
        }}
      >
        <SearchField value={searchValue} onChange={setSearchValue} />
      </Box>

      <Box
        className="layout-content-wrapper"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {entity === "strategy"
          ? filteredStrategyTickers.map((ticker, index) => (
              <CurrencyCard
                entity={entity}
                ticker={ticker}
                key={`ticker_${index}`}
                onChange={handleBase}
                onChangeQuote={handleQuote}
                fullWidth={false}
              />
            ))
          : filteredTickers.map((ticker, index) => (
              <CurrencyCard
                entity={entity}
                ticker={ticker}
                key={`ticker_${index}`}
                onChange={handleBase}
                onChangeQuote={handleQuote}
                fullWidth={false}
              />
            ))}
        <Spacer height="10px" />
      </Box>
    </Box>
  );
};

export default TickerChooseList;
